import { resolveMediaUrl, releaseMediaUrl } from '@/service/secureMedia';

interface IBgContext {
    background: string;
    defaultBg: string;
    currentUrl: string;
}

/**
 * 设置组件 `background` 字段：
 * - SW 可用：维持原行为，用 `<Image>` 预加载校验 URL 后再切换
 * - SW 不可用：自动走主线程降级，用 `resolveMediaUrl` 取明文后包成 Blob URL
 *
 * 上层组件应在 `destroyed` 钩子里释放 `background.startsWith('blob:')` 的 URL，
 * 避免 Object URL 泄漏（`EventListItem.vue` 已有此逻辑）。
 */
export default function ( context: IBgContext, url: string ): void {

    context.background = context.defaultBg;

    if ( !url ) {

        return;

    }

    // 通过 secureMediaService 统一决议最终 URL（内部已处理 SW 状态等待）
    resolveMediaUrl( url, { mode: 'background' }).then(( finalUrl ) => {

        if ( context.currentUrl !== url ) {

            if ( finalUrl && finalUrl !== url ) {

                releaseMediaUrl( finalUrl );

            }
            return;

        }

        if ( finalUrl === url || !finalUrl ) {

            // SW 可用（原 URL）或降级失败：Image 预加载路径
            const img = new Image();
            img.src = url;
            img.onload = () => {

                if ( context.currentUrl === url ) {

                    context.background = url;

                }

            };
            img.onerror = () => {

                if ( context.currentUrl === url ) {

                    context.background = context.defaultBg;

                }

            };
            return;

        }

        // 降级成功：使用 blob URL
        const previous = context.background;
        if ( previous && previous.startsWith( 'blob:' ) && previous !== context.defaultBg ) {

            releaseMediaUrl( previous );

        }
        context.background = finalUrl;

    }).catch( console.error );

}
